import { AxiosError } from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useClickAway } from 'react-use';
import { ErrorInfo, UserSearchItem } from '../../../api/model';
import { usePostUsersDelete } from '../../../api/users/users';
import { useDefaultOptions } from '../../../hooks/api';
import ConfirmModal from '../../modules/ConfirmModal';

type Props = {
  user: UserSearchItem;
  refetch: () => void;
};

function UserRemove({ user, refetch }: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);
  const [open, setOpen] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);

  const ref = useRef(null);
  useClickAway(ref, () => {
    setOpen(false);
  });

  const { mutateAsync, isSuccess } = usePostUsersDelete<AxiosError<ErrorInfo>, unknown>(options);
  const handleDeleteUsers = () => {
    const postUserDelete = async () => {
      if (!user.user_id) return;

      await mutateAsync({
        data: { user_id: [user.user_id] },
      });
    };

    void postUserDelete();
  };

  useEffect(() => {
    if (isSuccess) refetch();
  }, [refetch, isSuccess]);

  return (
    <td className="elloutput">
      {!user.deleted && (
        <>
          <i className="fa-solid fa-ellipsis-vertical" onClick={() => setOpen(true)} />
          <div className={open ? 'open' : ''} ref={ref} onClick={() => setIsConfirm(true)}>
            <span>
              <i className="fa-solid fa-circle-xmark" />
              {t('削除')}
            </span>
          </div>
        </>
      )}

      {isConfirm && (
        <ConfirmModal onClickOk={() => handleDeleteUsers()} onClickCancel={() => setIsConfirm(false)}>
          <div className="poptxt">
            <p>{t('削除します。よろしいですか？')}</p>
          </div>
        </ConfirmModal>
      )}
    </td>
  );
}

export { UserRemove };
